import React from "react";
import useRole from "../hooks/useRole"; // Poprawna ścieżka do Hooka

const AdminPanel = () => {
  const hasAccess = useRole("admin");

  if (!hasAccess) {
    return <div>Access Denied</div>;
  }

  return <div>Welcome to Admin Panel</div>;
};

export default AdminPanel;